<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('tab_pane_label_baseInfo') || '基本信息'"
        name="baseInfo"
      >
        <BaseInfo
          ref="baseInfo"
          :shipmentCustomerCode="shipmentCustomerCode"
          :disabled="disabled"
        />
        <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
          <el-button type="primary" size="small" @click="$refs.baseInfo.save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_pane_label_address') || '相关地址'"
        name="customerAddress"
        lazy
      >
        <CustomerAddress
          ref="customerAddress"
          :shipmentCustomerCode="shipmentCustomerCode"
          :disabled="disabled"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_pane_label_file') || '相关附件'"
        name="customerFile"
        lazy
      >
        <CustomerFile
          ref="customerFile"
          :shipmentCustomerCode="shipmentCustomerCode"
          :disabled="disabled"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BaseInfo from '../components/base-info'
import CustomerAddress from '../components/customer-address'
import CustomerFile from '../components/customer-file'
export default {
  name: 'transport-shipperConsignee-detail',
  components: { BaseInfo, CustomerAddress, CustomerFile },
  data() {
    return { activeName: 'baseInfo' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    shipmentCustomerCode() {
      return this.params.code
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
